// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---node-modules-shapeable-gatsby-theme-shapeable-src-components-app-tsx": () => import("./../../../node_modules/@shapeable/gatsby-theme-shapeable/src/components/app.tsx" /* webpackChunkName: "component---node-modules-shapeable-gatsby-theme-shapeable-src-components-app-tsx" */),
  "component---node-modules-shapeable-gatsby-theme-shapeable-src-pages-404-tsx": () => import("./../../../node_modules/@shapeable/gatsby-theme-shapeable/src/pages/404.tsx" /* webpackChunkName: "component---node-modules-shapeable-gatsby-theme-shapeable-src-pages-404-tsx" */)
}

